import React from "react";
import { IconPresentationProps } from "@insite/mobius/Icon/Icon";

const Boxes: React.ComponentType<IconPresentationProps> = (props) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        width="12"
        height="13"
        viewBox="0 0 12 13"
        {...props}
    >
        <path
            fill="currentColor"
            d="M5.25 0.5L5.25 2C5.25 2.2109375 5.4140625 2.375 5.625 2.375L6.375 2.375C6.5859375 2.375 6.75 2.2109375 6.75 2L6.75 0.5L7.5 0.5C8.3203125 0.5 9 1.1796875 9 2L9 5C9 5.140625 8.9765625 5.2578125 8.953125 5.375L3.046875 5.375C3.0234375 5.2578125 3 5.140625 3 5L3 2C3 1.1796875 3.6796875 0.5 4.5 0.5L5.25 0.5ZM7.5 12.5C7.2421875 12.5 6.984375 12.429688 6.7734375 12.3125C7.0078125 11.9375 7.125 11.46875 7.125 11L7.125 8C7.125 7.53125 7.0078125 7.0859375 6.7734375 6.6875C6.984375 6.5703125 7.2421875 6.5 7.5 6.5L8.25 6.5L8.25 8C8.25 8.2109375 8.4140625 8.375 8.625 8.375L9.375 8.375C9.5859375 8.375 9.75 8.2109375 9.75 8L9.75 6.5L10.5 6.5C11.320312 6.5 12 7.1796875 12 8L12 11C12 11.820312 11.320312 12.5 10.5 12.5L7.5 12.5ZM0 8C0 7.1796875 0.6796875 6.5 1.5 6.5L2.25 6.5L2.25 8C2.25 8.2109375 2.4140625 8.375 2.625 8.375L3.375 8.375C3.5859375 8.375 3.75 8.2109375 3.75 8L3.75 6.5L4.5 6.5C5.3203125 6.5 6 7.1796875 6 8L6 11C6 11.820312 5.3203125 12.5 4.5 12.5L1.5 12.5C0.6796875 12.5 0 11.820312 0 11L0 8Z"
        />
    </svg>
);

export default Boxes;